import { Typography } from '@mui/material';

import { formatDate, replaceDateWithUserTimeZone } from '@shared/commonFunctions';
import { GridCell } from '@shared/components/grid/GridCell';
import { dateFormatSmallWithTime } from '@shared/constants/formats';
import { CommentHeader, CommentWrapper } from '@styles/ContactManager/CommentsTabStyles';
// import { colorTheme } from '@styles/muiTheme';
import { IComment } from './types';

interface ICommentProps {
  data: IComment;
  filter: string;
}

const systemAdminName = 'sa';
const systemAdminText = 'System';

const createMarkUp = (html:string) => {
  return { __html: html };
};

export const Comment = ({ data }: ICommentProps) => {
  const formattedDateText = replaceDateWithUserTimeZone(data?.text);

  return (
    <CommentWrapper color={data?.background || ''}>
      <CommentHeader direction="column">
        <GridCell isBold text={data.name === systemAdminName ? systemAdminText :  data.name || ''} />
        <Typography fontSize="12px" >{formatDate(data?.createdDate, { format: dateFormatSmallWithTime })}</Typography>
      </CommentHeader>

      {data?.isTextBold ?
        <Typography fontWeight="bold" fontSize="12px">{formattedDateText}</Typography>
        : data.highlightedText ? <Typography display="unset" component={'span'} dangerouslySetInnerHTML={createMarkUp(data.highlightedText)} /> 
        : <Typography display="unset" sx={{paddingLeft: '6px', paddingRight: '2px'}} component={'span'} >{formattedDateText}</Typography>
      }
    </CommentWrapper>
  );
};

